import {NgModule} from '@angular/core';
import {NgSelectModule} from '@ng-select/ng-select';
import {DataTableDaoService, NoteAttachmentsDaoService} from '@q9elements/ui-kit/attachments';
import {AddOrgModelNodeDialogComponent} from './dialogs/search-org-model-dialog/add-org-model-node-dialog.component';
import {AttachmentsService} from './attachments.service';
import {DiagramDataTableDaoService} from './services/diagram-data-table-dao.service';
import {Q9HtmlEncoderPipe} from '@q9elements/ui-kit/common';
import {DiagramNoteAttachmentsService} from './services/note-attachment.service';

@NgModule({
  imports: [NgSelectModule, AddOrgModelNodeDialogComponent],
  declarations: [],
  providers: [
    AttachmentsService,
    Q9HtmlEncoderPipe,
    {provide: DataTableDaoService, useExisting: DiagramDataTableDaoService},
    {provide: NoteAttachmentsDaoService, useClass: DiagramNoteAttachmentsService}
  ]
})
export class AttachmentsModule {}
